import React from 'react';
import {Paper, Table, TableBody, TableRow, TableRowColumn} from 'material-ui';
import {observer, inject} from 'mobx-react';
import {cmURL} from '../libs/config'
import TextTruncate from './common/TextTruncate';

@inject('contentStore')
@observer
class CommunityOutreach extends React.Component {

  pdfList = [
    [
      {name:'Devchuli, Nawalparasi', url:'http://hydrology.gov.np/new/hydrology/_files/9cea64f0b4c3437e5549064eaa27d6fd.pdf'},
      {name:'Pragatinagar, Nawalparasi', url:'http://hydrology.gov.np/new/hydrology/_files/5f87915e3a83f757a24c9b90715bd893.pdf'},
      {name:'Narayani and East Rapti, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/896ec4d5be46d9205820d6c29fdeddb8.pdf'},
      {name:'Meghauli, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/ae7eabbf30ebfd84cae3b48e5730424f.pdf'}
    ],
    [
      {name:'Patihani, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/ff6a805455888f167f20b9f7e0b33c72.pdf'},
      {name:'West Rapti, Banke', url:'http://hydrology.gov.np/new/hydrology/_files/e29ba77623d63e71796a2388ac2b8617.jpg'},
      {name:'Community based System for Bardiya', url:'http://hydrology.gov.np/new/hydrology/_files/9b8714a678ed387db6f9182aac4f2725.jpg'}
    ]
  ];

  pdfTable = [
    {name:'Devchuli, Nawalparasi', url:'http://hydrology.gov.np/new/hydrology/_files/9cea64f0b4c3437e5549064eaa27d6fd.pdf'},
    {name:'Pragatinagar, Nawalparasi', url:'http://hydrology.gov.np/new/hydrology/_files/5f87915e3a83f757a24c9b90715bd893.pdf'},
    {name:'Narayani and East Rapti, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/896ec4d5be46d9205820d6c29fdeddb8.pdf'},
    {name:'Meghauli, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/ae7eabbf30ebfd84cae3b48e5730424f.pdf'},
    {name:'Patihani, Chitwan', url:'http://hydrology.gov.np/new/hydrology/_files/ff6a805455888f167f20b9f7e0b33c72.pdf'},
    {name:'West Rapti, Banke', url:'http://hydrology.gov.np/new/hydrology/_files/e29ba77623d63e71796a2388ac2b8617.jpg'},
    {name:'Community based System for Bardiya', url:'http://hydrology.gov.np/new/hydrology/_files/9b8714a678ed387db6f9182aac4f2725.jpg'},
  ];

  render() {
    let community_outreach = this.props.contentStore.community_outreach;
    return(
      <div className="inline-it">
        <Paper zDepth={2}>
          <Table style={{maxWidth:'1000px'}}>
            <TableBody displayRowCheckbox={false}
                       showRowHover={false}
                       stripedRows={true}>{
              community_outreach.length>0 && community_outreach.map((item, index) => (
                <TableRow selectable={false} key={index}>
                  <TableRowColumn style={{paddingTop:item.description==='5px'?'':'10px', whiteSpace:'normal'}}>
                    <a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer" className="content-title">{item.title}</a>
                    {/*<p>{item.description}</p>*/}
                    <TextTruncate text={item.description} />
                  </TableRowColumn>
                </TableRow>
              ))
            }</TableBody>
          </Table>
        </Paper>
      </div>
    );

    // return (
    //   <table className="grid-table">
    //     <tbody>{
    //       this.pdfList.map(trlist => (
    //        <tr>{
    //          trlist.map(pdf => (
    //            <td>
    //              <Paper zDepth={2} id="my-div" style={{border:'1px #0f72a9 solid'}}>
    //                <iframe src={pdf.url}
    //                        id="my-iframe" width="181" height="207" scrolling="no" title="Devchuli, Nawalparasi"/>
    //                <a href={pdf.url} target="_blank"
    //                   rel="noopener noreferrer">
    //                  <p style={{marginTop: '160px', fontSize:'15px'}} className="myTableHead">{pdf.name}</p>
    //                </a>
    //              </Paper>
    //            </td>
    //          ))
    //        }</tr>
    //       ))
    //     }</tbody>
    //   </table>
    // );
  }
}

export default CommunityOutreach;


// WEBPACK FOOTER //
// ./src/components/CommunityOutreach.js